import React, { useState } from 'react';
import { Link } from 'react-scroll';
import { useLanguage } from '../../i18n/LanguageContext';
import './style.css';

const MobileMenu = () => {
  const [menuActive, setMenuState] = useState(false);
  const { t, language, setLanguage } = useLanguage();

  const menuItems = [
    { title: t.nav.services, link: 'service' },
    { title: t.nav.work,     link: 'work' },
    { title: t.nav.results,  link: 'results' },
    { title: t.nav.contact,  link: 'contact' },
  ];

  const activeBtnStyle = {
    background: '#06b6d4', color: '#0d1117',
    border: 'none', borderRadius: '12px', padding: '4px 12px',
    fontWeight: 700, cursor: 'pointer', fontSize: '14px',
  };

  const inactiveBtnStyle = {
    background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.5)',
    border: '1px solid rgba(255,255,255,0.1)', borderRadius: '12px', padding: '4px 12px',
    fontWeight: 500, cursor: 'pointer', fontSize: '14px',
  };

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? 'show' : ''}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuState(false)}>
            <i className="ti-close"></i>
          </div>
        </div>
        <ul className="responsivemenu">
          {menuItems.map((item, i) => (
            <li key={i}>
              <Link
                to={item.link}
                spy smooth duration={500}
                onClick={() => setMenuState(false)}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.08)', marginTop: '8px' }}>
          <button style={language === 'en' ? activeBtnStyle : inactiveBtnStyle} onClick={() => setLanguage('en')}>EN</button>
          <span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
          <button style={language === 'es' ? activeBtnStyle : inactiveBtnStyle} onClick={() => setLanguage('es')}>ES</button>
        </div>
      </div>
      <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
        <button type="button" className="navbar-toggler open-btn">
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
